<template>
  <chat-message :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <ul class="chat-message__actions">
      <li
        v-for="language in availableLanguages"
        :key="language.locale"
        v-theme-bg-hover
        :class="language.selected ? 'choosen' : ''"
        @click="selectLanguage(language)"
      >
        {{ language.text }}
      </li>
    </ul>
  </chat-message>
</template>

<script>
import { EventBus } from 'ChatWidget/EventBus'
import { Chat } from 'src/apis'
import ChatMessage from 'Chats/ChatMessage'
import chatWidgetMixin from 'Chats/mixins/chatWidgetMixin'
import triplaLocalStorage from 'Utilities/triplaLocalStorage'
import { useSettingsStore } from 'Store/settings'

export default {
  components: { ChatMessage },
  mixins: [chatWidgetMixin],

  setup() {
    const settingsStore = useSettingsStore()
    return { settingsStore }
  },

  data: function () {
    return {
      active: this.chat.message_rich.active,
      actions: this.chat.message_rich.actions,
      availableLanguages: this.chat.message_rich.actions
    }
  },

  methods: {
    selectLanguage(language) {
      this.$i18n.locale = language.locale
      triplaLocalStorage.setItem('triplabot_locale', language.locale)
      EventBus.$emit('change-locale', language.locale)
      this.resetLocaleSelection()
      language.selected = true
      Chat.sendMessage(language.locale, { changeLanguage: language.locale })
      if (typeof window.triplaSearchBarChangeLocale === 'function') {
        window.triplaSearchBarChangeLocale(language.locale)
      }
      if (this.settingsStore.settings.booking_widget_is_active) {
        this.syncBwLocale(language.locale)
      }
    },
    syncBwLocale(selectedLocale) {
      const bwURL = new URL(this.settingsStore.bookingWidgetURL)
      const iframe = document.createElement('iframe')
      iframe.src = `${bwURL.origin}/iframe-change-locale?locale=${selectedLocale}`
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      setTimeout(() => {
        document.body.removeChild(iframe)
      }, 3000)
    },
    resetLocaleSelection() {
      this.availableLanguages.map((language) => {
        language.selected = false
      })
    }
  }
}
</script>
